import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "../../../../components";

class MigrateModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			show: false,
			organizationId: "",
			users: 0,
			replacementId: "",
			deleteOrMigrate: "delete",
		};

		this.initialState = { ...this.state };
	}

	openModal = ({ organizationId, users }) => {
		this.setState({
			show: true,
			organizationId,
			users,
		});
	};

	closeModal = () => {
		this.setState({
			...this.initialState,
		});
	};

	onChange = property => event => {
		this.setState({ [property]: event.target.value });
	};

	onConfirm = () => {
		const { onConfirm } = this.props;
		const { organizationId, replacementId, deleteOrMigrate } = this.state;

		onConfirm(organizationId, deleteOrMigrate === "migrate" ? replacementId : undefined);
		this.closeModal();
	};

	render() {
		const { show, deleteOrMigrate, organizationId, users, replacementId } = this.state;

		const { lang } = global;

		return (
			<Modal
				className="confirmation-modal"
				show={show}
				onHide={this.closeModal}
			>
				<Modal.Header>
					<Modal.Title>{lang.t("Delete Organization")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>
						{lang.t(
							"dynamic.Do you want to delete or migrate those user(s) to another organization",
							{ organizationId, users },
						)}
					</p>
					<br />
					<div className="radio">
						<label htmlFor="delete">
							<input
								type="radio"
								name="migrateQuestion"
								id="delete"
								value="delete"
								checked={deleteOrMigrate === "delete"}
								onChange={this.onChange("deleteOrMigrate")}
							/>
							{lang.t("Delete")}
						</label>
					</div>
					<div className="radio">
						<label htmlFor="migrate">
							<input
								type="radio"
								name="migrateQuestion"
								id="migrate"
								value="migrate"
								checked={deleteOrMigrate === "migrate"}
								onChange={this.onChange("deleteOrMigrate")}
							/>
							{lang.t("Migrate")}
						</label>
					</div>
					<If condition={deleteOrMigrate === "migrate"}>
						<label
							htmlFor="replacementId"
							className="control-label"
						>
							{lang.t("Organization ID")}
							<input
								type="text"
								name="replacementId"
								id="replacementId"
								value={replacementId}
								className="form-control"
								onChange={this.onChange("replacementId")}
							/>
						</label>
					</If>
				</Modal.Body>
				<Modal.Footer>
					<button
						type="button"
						className="btn btn-link"
						onClick={this.closeModal}
					>
						{lang.t("Cancel")}
					</button>
					<button
						type="button"
						className="btn btn-primary"
						onClick={this.onConfirm}
					>
						{lang.t("Confirm")}
					</button>
				</Modal.Footer>
			</Modal>
		);
	}
}

MigrateModal.propTypes = {
	onConfirm: PropTypes.func.isRequired,
};

export default MigrateModal;
